import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultButton } from '~/components/atomic';

export const Container = styled.div`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    height: 100%;
    padding: ${theme.layout.chat_header_height} 16px
      ${theme.layout.chat_navigation_height};
  `}
`;

export const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const ImageBox = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  text-align: center;

  img {
    display: block;
    width: auto;
    max-width: 100%;
    max-height: 350px;
  }
`;

export const Title = styled.strong`
  font-family: 'Poppins', sans-serif;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: -0.3;
  line-height: 1.2;
`;

export const DescBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  text-align: center;
`;

export const Desc = styled.p`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    ${theme.fontStyle.poppins.sub_title}
    color: ${theme.content.content_light_1};
  `}
`;

export const SubDesc = styled.p`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    ${theme.fontStyle.text.body14_medium}
    color: ${theme.content.content_light_1};

    & > em {
      color: ${theme.themeColor.main_1};
    }
  `}
`;

export const SignInSuccessButton = styled(DefaultButton)`
  width: 160px;
  padding: 0 20px;
`;
